import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import type {
  OverviewEntity,
  OverviewPartialState,
  OverviewState} from './overviews.reducer';
import {
  OVERVIEWS_FEATURE_KEY,
  overviewsAdapter
} from './overviews.reducer';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { differenceInSeconds } from 'date-fns';

const { selectEntities } = overviewsAdapter.getSelectors();

export const selectOverviewState = createFeatureSelector<OverviewState>(OVERVIEWS_FEATURE_KEY);

const selectOverviewEntities = createSelector(selectOverviewState, (state: OverviewState) => selectEntities(state));

export const selectCurrentOverviewId = createSelector(
  selectOverviewState,
  (state: OverviewState) => state.currentOverviewId
);

export const selectCurrentOverview = createSelector(
  selectOverviewEntities,
  selectCurrentOverviewId,
  (entities, id) => entities[id]
);

export const getCurrentSelectedOverview = pipe(
  select(selectCurrentOverview),
  filter((x) => !!x && x.status === 'Loaded'),
  distinctUntilChanged((a, b) => {
    if (a.storeId !== b.storeId) {
      return false;
    }

    const diff = differenceInSeconds(new Date(b.fetchDate), new Date(a.fetchDate));
    console.log('Double event date diff filter: ', diff);

    return diff < 60;
  })
);

export const getOverviewByStoreId = createSelector<
  OverviewPartialState,
  { id: string },
  Record<string, OverviewEntity>,
  OverviewEntity
>(selectOverviewEntities, (articleEntities, props) => articleEntities[props.id]);
